import { render, staticRenderFns } from "./button-style.vue?vue&type=template&id=83d72d78&scoped=true&"
import script from "./button-style.vue?vue&type=script&lang=js&"
export * from "./button-style.vue?vue&type=script&lang=js&"
import style0 from "./button-style.vue?vue&type=style&index=0&id=83d72d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d72d78",
  null
  
)

export default component.exports